export default {
      id: "hr-usage",
      viewBox: "0 0 129.65 15.875",
      url: __webpack_public_path__ + "img/icons.fcdc0825.svg#hr",
      toString: function () {
        return this.url;
      }
    }